import React from "react";
import Loader from "./Loader";
import { Grid } from "@mui/material";
import {
  OnGoingDocumentDisplayWrapper,
  OngoingText,
} from "../styled/StyledOnGoingDocumentDisplay.styled";

function OnGoingDocumentDisplay({ fileName }) {
  return (
    <OnGoingDocumentDisplayWrapper>
      <OngoingText>Ongoing Processing Files</OngoingText>
      <Grid
        container
        spacing={0}
        justifyContent={"flex-start"}
        alignItems={"center"}
      >
        <Grid item xs={12} md={4}>
          <OngoingText align={"left"}>{fileName} </OngoingText>
        </Grid>
        <Grid item xs={12} md={4}>
          <Loader />
        </Grid>
        <Grid item xs={12} md={4}>
          <OngoingText align={"right"}>
            {fileName} file is under processing please wait.
          </OngoingText>
        </Grid>
      </Grid>
    </OnGoingDocumentDisplayWrapper>
  );
}

export default OnGoingDocumentDisplay;
